export default __webpack_public_path__ + "img/06c029ba31527ed38d7e01157121828b.svg";